export default __webpack_public_path__ + "static/media/Priest's Crest of Balance.6e798983.jpg";